import { AgGridReact } from '@ag-grid-community/react';
import { useAgGrid } from '@tassat/ag-grid';
import React from 'react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-material.css';

import { highlightLockedRow } from 'Lib/agGridHelper';
import { useAppSelector } from 'Reducers/store/hooks';
import { getAPIConnectionUsersFromAPIFirmAndAPIConnection } from 'Selectors/apiFirms';
import { ActionButtonsCellRenderer } from 'SharedComponents/cellRenderComponent/actionButtonsCellRenderer';

import { usersColumnDefs } from './apiConnectionFirmUsersGridOptions';

import type { IApiConnectionFirmUsersGridProps } from '.';

import 'SharedComponents/agGrid/styles/agGridOverrides.css';

export function ApiConnectionFirmUsersGrid (props: IApiConnectionFirmUsersGridProps) {
    const { apiConnectionFirmId } = props;

    const apiFirmUsers = useAppSelector((state) => getAPIConnectionUsersFromAPIFirmAndAPIConnection(state, apiConnectionFirmId));
    const [ ,onGridReady ] = useAgGrid();

    return (
        <div
            className='ag-theme-material'
            id='apiConnectionFirmUsersGrid'
            style={{ height: '100%' }}
        >
            <AgGridReact
                animateRows={false}
                columnDefs={usersColumnDefs}
                columnMenu='legacy'
                components={{ actionButtonsCellRenderer: ActionButtonsCellRenderer }}
                defaultColDef={{
                    resizable: true,
                    filter: true,
                    sortable: true
                }}
                enableCellTextSelection={true}
                getRowClass={(params) => highlightLockedRow(params, 'apiUser.IsLocked')}
                onGridReady={onGridReady}
                rowData={apiFirmUsers}
                suppressCellFocus={true}
                suppressContextMenu={true}
            />
        </div>
    );
}